// API endpoint - update this with your actual API Gateway URL
export const API_CONFIG = {
  endpoint: import.meta.env.VITE_API_ENDPOINT || 'https://your-api-gateway-url.execute-api.eu-west-2.amazonaws.com/prod/submit',
  timeout: 30000 // 30 seconds
};

// Form field configurations matching your Lambda expectations
export const FORM_FIELDS = {
  // Question 2: Character of pain
  CHARACTER_PAIN_OPTIONS: [
    "sharp",
    "dull ache",
    "burning",
    "tight",
    "squeezing",
    "pressure",
    "stabbing"
  ],
  
  // Question 3: Radiation
  RADIATE_OPTIONS: [
    "does not radiate",
    "radiates to the left arm",
    "radiates to the right arm",
    "radiates to the neck"
  ],
  
  // Question 5: Frequency
  FREQUENCY_OPTIONS: [
    "daily",
    "weekly",
    "monthly",
    "yearly",
    "constant",
    "one-off episode"
  ],
  
  // Question 6: Worsening factors
  WORSENED_BY_OPTIONS: [
    "exercise",
    "walking up stairs",
    "external pressure on chest wall",
    "twisting movements",
    "cold weather",
    "eating",
    "deep breaths",
    "stress",
    "laying flat",
    "coughing",
    "randomly worsens",
    "nothing"
  ],
  
  // Question 7: Relieving factors
  RELIEVED_BY_OPTIONS: [
    "rest from exercise",
    "paracetamol / ibuprofen",
    "glyceryl trinitrate (GTN) spray",
    "sitting upright",
    "antacids (Gaviscon, milk of magnesia etc)",
    "randomly improves",
    "nothing"
  ],
  
  // Question 8: Smoking status
  SMOKE_OPTIONS: [
    "current smoker",
    "non-smoker",
    "ex-smoker (quit within 1 year)",
    "ex-smoker (quit for more than 1 year)"
  ],
  
  // Question 9: Risk factors
  RISK_FACTORS_OPTIONS: [
    "diabetes",
    "high cholesterol",
    "previous heart attack",
    "kidney disease (ckd)",
    "coronary artery bypass grafts (cabg)",
    "cardiac stents (pci)",
    "hypertension (high blood pressure)",
    "no cardiac risk factors"
  ],
  
  // Question 12: Gender
  GENDER_OPTIONS: [
    "Male",
    "Female"
  ]
};
